import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import ReactDOMServer from 'react-dom/server';
import { getLabelTextWithDate, getTooltipText } from '../../../agent-production/helpers/uiHelpers';
import { CustomInput } from '@lwt-helix/controls';
import { Col, Row } from '@lwt-helix/layout';
import { FormGroup } from '@lwt-helix/form';

export const MetricsContent = ({ columns, setColumns }) => {
    const ref = useRef();

    const metricsGroups = columns.reduce((acc, column) => {
        if (!column.metrics?.id) return acc;

        if (!acc[column.metrics.id]) {
            acc[column.metrics.id] = {
                ...column.metrics,
                columns: []
            };
        }

        acc[column.metrics.id].columns.push(column);
        return acc;
    }, {});

    useEffect(() => {
        ReactTooltip.rebuild();
    }, []);

    const renderMetricsTooltip = (data) => {
        const metricDescription = JSON.parse(data);
        return (
            metricDescription?.metricDescription &&
            ReactDOMServer.renderToString(
                <div className="text-left">
                    <div className="w-100">{metricDescription.metricDescription}</div>
                </div>
            )
        );
    };

    const writeInput = (column, index) => {
        const elementId = `agent-movement-metrics-selector-${column.id}`;
        const label = getLabelTextWithDate(column);
        const tooltipProps = {
            'data-for': 'metrics-selector-tooltip',
            'data-tip': JSON.stringify({
                metricDescription: getTooltipText(column)
            })
        };
        return (
            <>
                <div
                    {...tooltipProps}
                    ref={ref}
                >
                    <CustomInput
                        dataLwtId={elementId}
                        id={elementId}
                        key={index}
                        value={column.id}
                        defaultChecked={column.isDisplayed}
                        disabled={false}
                        type="checkbox"
                        label={label}
                        onClick={(e) =>
                            setColumns({ columnId: column.id, isDisplayed: e.target.checked })
                        }
                    />
                </div>
                <ReactTooltip
                    id="metrics-selector-tooltip"
                    className="metrics-selector-tooltip"
                    type="info"
                    effect="solid"
                    place="left"
                    backgroundColor="black"
                    getContent={renderMetricsTooltip}
                    html={true}
                />
            </>
        );
    };
    return (
        <>
            <Row>
                {Object.values(metricsGroups).map((group, index) => (
                    <Col
                        key={index}
                        {...group.colProps}
                    >
                        <FormGroup>
                            <div
                                dataLwtId={'lbl-total-list'}
                                className="filter-header"
                            >
                                {group.label}
                            </div>
                            {group.columns.map((column, index) => writeInput(column, index))}
                        </FormGroup>
                    </Col>
                ))}
            </Row>
        </>
    );
};

MetricsContent.propTypes = {
    columns: PropTypes.array.isRequired,
    setColumns: PropTypes.func.isRequired
};
